import { User, IUser } from '@/models/user';
import { Consts } from '@/consts';
import { GraphApiResult } from '@/models/graphApiResult';
import { ApiResult } from '@/enums';
import { StringUtils } from './stringUtils';
import { Tasks, ITasks } from '@/models/tasks';

export class UserUtils {
	public static async GetMe(accessToken: string): Promise<GraphApiResult<User>> {
		const result = new GraphApiResult<User>();
		try {
			if (StringUtils.IsEmptyOrUndefined(accessToken)) {
				result.result = ApiResult.ParameterError;
				return result;
			}

			const headers = new Headers();
			const bearer: string = 'Bearer ' + accessToken;
			headers.append('Authorization', bearer);
			const options = {
				method: 'GET',
				headers
			};

			try {
				const response: Response = await fetch(Consts.GRAPH_API_BASE_URL + 'me', options);
				const iuser = await response.json() as IUser;
				const user = User.parse(iuser);
				if ((user.id == null) || (user.id === '')) {
					result.result = ApiResult.ParseError;
					return result;
				}
				result.result = ApiResult.Success;
				result.value = user;
				return result;
			} catch (error) {
				console.error(error.message);
				result.result = ApiResult.ResponseError;
				return result;
			}
		} catch (error) {
			console.error(error.message);
			result.result = ApiResult.UnknownError;
			return result;
		}
	}

	public static async GetTasks(accessToken: string): Promise<GraphApiResult<Tasks>> {
		const result = new GraphApiResult<Tasks>();
		try {
			if (StringUtils.IsEmptyOrUndefined(accessToken)) {
				result.result = ApiResult.ParameterError;
				return result;
			}

			const headers = new Headers();
			const bearer: string = 'Bearer ' + accessToken;
			headers.append('Authorization', bearer);
			const options = {
				method: 'GET',
				headers
			};

			try {
				const url: string = `${Consts.GRAPH_API_BASE_URL}me/planner/tasks`;
				const response: Response = await fetch(url, options);
				const itasks = await response.json() as ITasks;
				const tasks = Tasks.parse(itasks);
				result.result = ApiResult.Success;
				result.value = tasks;
				return result;
			} catch (error) {
				console.error(error.message);
				result.result = ApiResult.ResponseError;
				return result;
			}
		} catch (error) {
			console.error(error.message);
			result.result = ApiResult.UnknownError;
			return result;
		}
	}
}
